import { PaginationProps } from 'antd/lib/pagination';
import { set } from 'lodash';
import { useEffect } from 'react';
import history from '@helpers/history';
import { getQuery } from '@helpers/navigation';
import qs from 'qs';
import { Event } from 'effector';

const useListWithQuery = (
  getList: (params: { filters?: Record<string, any>; pagination?: PaginationProps }) => void,
  reset: Event<void>,
) => {
  useEffect(() => {
    const query = getQuery();
    const { size, page, ...filters } = query;
    const requestParams = {};
    if (size) set(requestParams, ['pagination', 'pageSize'], +size);
    if (page) set(requestParams, ['pagination', 'current'], +page + 1);
    if (Object.keys(filters).length) set(requestParams, ['filters'], filters);
    getList(requestParams);

    const routePathname = history.location.pathname;
    const historyUnlisten = history.listen((location, action) => {
      const nextPathname = location.pathname;
      if (routePathname === nextPathname && ['PUSH', 'POP'].includes(action)) {
        const filters = qs.parse(location.search, {
          ignoreQueryPrefix: true,
        });
        getList({ filters });
      }
    });

    return () => {
      reset();
      historyUnlisten();
    };
    // eslint-disable-next-line
  }, []);
};

export default useListWithQuery;
